<template>
  <v-card outlined class="h100 card-height">
    <v-list-item three-line>
      <v-list-item-content>
        <div class="mb-4">
          {{ typeDocument | typedocument }}
        </div>
        <v-list-item-title class="text-h6 mb-1">
          <span v-if="nomDocument">
            {{ nomDocument }}
          </span>
          <span v-else> &nbsp; </span>
        </v-list-item-title>
        <v-list-item-subtitle v-if="destinataire">
          <div v-if="destinataire.libelle">Pour {{ destinataire.libelle }}</div>

          <div v-if="destinataire.pourvoi">
            {{ destinataire.pourvoi | typepourvoi }}
            <span v-if="destinataire.lrar">- Lettre avec accusé de réception</span>
          </div>
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          <span v-if="tailleDocument">
            {{ tailleDocument | bytes }}
          </span>
          <span v-else> &nbsp; </span>
        </v-list-item-subtitle>
      </v-list-item-content>
      <div class="actions-icons">
        <template v-if="telechargeable">
          <a-tooltip-icon-button
            icon="mdi-eye"
            tooltip="Consulter le document"
            :loading="telechargement"
            @click="telecharge"
            data-testid="consulter-document"
          />
        </template>
      </div>
    </v-list-item>
    <v-card-actions v-if="demandePieces">
      <v-hover v-slot="{ hover }">
        <v-btn
          block
          :outlined="hover"
          depressed
          color="warning"
          @click="versDemandePieces"
          data-testid="demande-pieces"
        >
          <v-icon>mdi-alert</v-icon>
          Répondre à la demande de pièces
        </v-btn>
      </v-hover>
    </v-card-actions>
  </v-card>
</template>

<script>
import { documentService } from "@/services";
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      telechargement: false,
    };
  },

  methods: {
    telecharge() {
      if (this.$listeners.telecharge) {
        this.$emit("telecharge", this.value);
        return;
      }

      this.telechargement = true;
      documentService
        .telechargeBlob(this.value.nom, this.value.lien)
        .finally(() => (this.telechargement = false));
    },

    versDemandePieces() {
      var d = this.demandePieces;
      this.$router.push({
        name: "pieces",
        params: {
          id: `${d.requete}-${d.code}`,
          auth: true,
        },
      });
    },
  },

  computed: {
    demandePieces() {
      return this.value.demandePieces;
    },
    telechargeable() {
      return !!this.value.lien;
    },
    tailleDocument() {
      return this.value.taille;
    },
    nomDocument() {
      return this.value.nom;
    },
    typeDocument() {
      return this.value.type;
    },
    destinataire() {
      return this.value.destinataire;
    },
  },
};
</script>

<style scoped>
.actions-icons {
  align-self: flex-end;
  margin: 5px;
  justify-self: flex-end !important;
  position: absolute;
  right: 0;
}
</style>
